import _words from "lodash/words";
const tokenize = (text: string): string[] => {
    return _words(text.toLowerCase()).filter(word => word.trim() !== '');
};

export default tokenize;
